import React from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { makeStyles } from '@material-ui/styles';
import { Avatar, Box } from '@material-ui/core';

// third-party

// assets
import { IconBell } from '@tabler/icons';

// style constant
const useStyles = makeStyles((theme) => ({
    headerAvatar: {
        ...theme.typography.commonAvatar,
        ...theme.typography.mediumAvatar,
        transition: 'all .2s ease-in-out',
        background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.secondary.light,
        color: theme.palette.mode === 'dark' ? theme.palette.warning.dark : theme.palette.secondary.dark,
        '&[aria-controls="menu-list-grow"],&:hover': {
            background: theme.palette.mode === 'dark' ? theme.palette.warning.dark : theme.palette.secondary.dark,
            color: theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.secondary.light
        }
    },
    box: {
        display: 'flex',
        alignItems: 'center'
    }
}));

// ===========================|| NOTIFICATION ||=========================== //

const NotificationSection = () => {
    const classes = useStyles();

    return (
        <>
            <Box component="span" className={classes.box}>
                <Link to="/notifications">
                    <Avatar variant="rounded" className={classes.headerAvatar} aria-haspopup="true" color="inherit">
                        <IconBell stroke={1.5} size="1.3rem" />
                    </Avatar>
                </Link>
            </Box>
        </>
    );
};

export default NotificationSection;
